import {
  Box,
  Button,
  Card,
  CircularProgress,
  Grid,
  InputAdornment,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import axios from "axios";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import {
  SHRIMP_DATA_BY_MOBILE_NO,
  SHRIMP_REMARK_SUBMIT,
} from "../../../constants";
import { set } from "date-fns";

const FormComponent = ({
  setFormOpen,
  setOpenSnackbar,
  setSeverity,
  setMessage,
  FormMobileNo,
  callID,
  callType,
}) => {
  const [isNeworExisting, setIsNewOrExisting] = useState("old");
  const [mobileNumber, setMobileNumber] = useState("");
  const [farmer_name, setFarmer_Name] = useState("");
  const [farmerCategory, setFarmerCategory] = useState("");
  const [buisnessType, setBuisnessType] = useState("");
  const [pondLocation, setPondLocation] = useState("");
  const [district, setDistrict] = useState("");
  const [pincode, setPincode] = useState("");
  const [state, setState] = useState("");
  const [fishSpecies, setFishSpecies] = useState("");
  const [noOfPonds, setNoOfPonds] = useState("");
  const [noOfTank, setNoOfTank] = useState("");
  const [pondArea, setPondArea] = useState("");
  const [currentfeed, setCurrentFeed] = useState("");
  const [stocking, setStocking] = useState("");
  const [stockingDensity, setStockingDensity] = useState("");
  const [daysOfCulture, setDaysOfCulture] = useState("");
  const [harvesting, setHarvesting] = useState("");
  const [harvestingQuantity, setHarvestingQuantity] = useState("");
  const [potentiality, setPotentiality] = useState("");
  const [status, setStatus] = useState("");
  const [followUpDate, setFollowUpDate] = useState("");
  const [remarks, setRemarks] = useState("");
  const [purpose, setPurpose] = useState("");

  const [mobileNumberError, setMobileNumberError] = useState(false);
  const [purposeError, setPurposeError] = useState(false);
  const [feedUsedError, setFeedUsedError] = useState(false);
  const [stockinError, setStockingError] = useState(false);
  const [statusError, setStatusError] = useState(false);
  const [followUpDateError, setFollowUpDateError] = useState(false);
  const [buisnessTypeError, setBuisnessTypeError] = useState(false);
  const [mobileLoading, setMobileLoading] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (FormMobileNo !== "") {
      setMobileNumber(FormMobileNo);
      fetchDataByMobileNo(FormMobileNo);
    }
  }, [FormMobileNo]);

  const fetchDataByMobileNo = (mobNo) => {
    if (mobNo.length === 10) {
      setMobileLoading(true); // Start loading
      axios
        .get(`${SHRIMP_DATA_BY_MOBILE_NO}/${mobNo}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        })
        .then((response) => {
          const { masterDetails } = response.data.data;

          if (!masterDetails || Object.keys(masterDetails).length === 0) {
            // Handle case where lead is empty or null
            return; // Exit early
          }

          if (
            response.data.message === "No records found for this mobile number"
          ) {
            setSeverity("success");
            setMessage("No records found for this mobile number");
            setOpenSnackbar(true);
          } else {
            // Populate the state variables with the fetched lead data
            setFetchedLeadData(masterDetails, response.data.message);
          }
        })
        .catch((error) => {
          console.log(error);
          setSeverity("success");
          setMessage(error.response.data.message);
          setOpenSnackbar(true);
          // setMobileNumberError("Failed to fetch data. Please try again.");
        })
        .finally(() => {
          setMobileLoading(false); // Stop loading
        });
    }
  };

  const setFetchedLeadData = (masterDetails) => {
    // setOpenSnackbar(true);
    // setSeverity('success');
    // setMessage('Records Found');
    setFarmer_Name(masterDetails.dealerName);
    setIsNewOrExisting(masterDetails.farmerType);
    setState(masterDetails.state);
    setDistrict(masterDetails.district);
    setPincode(masterDetails.postalCode);
    setCurrentFeed(masterDetails.feedType);
    setRemarks(masterDetails.remarks);
    setNoOfTank(masterDetails.feedGodownCapacity);
    setFarmerCategory(masterDetails.prospectFarmerCategory);
  };

  const toNullIfEmpty = (value) => (value === "" ? null : value);

  const handleSubmit = () => {
    setLoading(true);

    // Validation for mandatory fields
    if (!mobileNumber) {
      setMobileNumberError(true);
      setSeverity("error");
      setMessage("Mobile Number is required.");
      setOpenSnackbar(true);
      setLoading(false);
      return;
    } else {
      setMobileNumberError(false);
    }

    if (!buisnessType) {
      setBuisnessTypeError(true);
      setSeverity("error");
      setMessage("Service Type is required.");
      setOpenSnackbar(true);
      setLoading(false);
      return;
    } else {
      setBuisnessTypeError(false);
    }

    if (!currentfeed) {
      setFeedUsedError(true);
      setSeverity("error");
      setMessage("Current Feed is required.");
      setOpenSnackbar(true);
      setLoading(false);
      return;
    } else {
      setFeedUsedError(false);
    }

    if (!stocking) {
      setStockingError(true);
      setSeverity("error");
      setMessage("Stocking is required.");
      setOpenSnackbar(true);
      setLoading(false);
      return;
    } else {
      setStockingError(false);
    }

    if (!purpose) {
      setPurposeError(true);
      setSeverity("error");
      setMessage("Purpose is required.");
      setOpenSnackbar(true);
      setLoading(false);
      return;
    } else {
      setPurposeError(false);
    }

    if (!status) {
      setStatusError(true);
      setSeverity("error");
      setMessage("Status is required.");
      setOpenSnackbar(true);
      setLoading(false);
      return;
    } else {
      setStatusError(false);
    }

    if (status !== "Close" && !followUpDate) {
      setFollowUpDateError(true);
      setSeverity("error");
      setMessage("Follow-up Date is required.");
      setOpenSnackbar(true);
      setLoading(false);
      return;
    } else {
      setFollowUpDateError(false);
    }

    const formData = {
      type: "Regular",
      prospectFarmerCategory: toNullIfEmpty(farmerCategory),
      serviceType: toNullIfEmpty(buisnessType),
      name: toNullIfEmpty(farmer_name),
      mobileNumber: toNullIfEmpty(mobileNumber),
      pondLocation: toNullIfEmpty(pondLocation),
      district: toNullIfEmpty(district),
      postalCode: toNullIfEmpty(pincode),
      state: toNullIfEmpty(state),
      fishSpecies: toNullIfEmpty(fishSpecies),
      numberOfPonds: toNullIfEmpty(noOfPonds),
      pondAreaInAcres: toNullIfEmpty(pondArea),
      currentFeedUsed: toNullIfEmpty(currentfeed),
      isStocking: toNullIfEmpty(stocking),
      stockingDensity: toNullIfEmpty(stockingDensity),
      daysOfCulture: toNullIfEmpty(daysOfCulture),
      isHarvesting: toNullIfEmpty(harvesting),
      harvestingQuantity: toNullIfEmpty(harvestingQuantity),
      potentialityInMT: toNullIfEmpty(potentiality),
      status: status ?? null,
      followUpDate: status != "Close" ? followUpDate : null,
      purpose: toNullIfEmpty(purpose),
      remarks: toNullIfEmpty(remarks),
      callId: callID,
      callType: callType,
    };

    axios
      .post(SHRIMP_REMARK_SUBMIT, formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      })
      .then((response) => {
        console.log("here", response);

        setSeverity("success");
        setMessage(response.data.message);
        setOpenSnackbar(true);

        setFormOpen(false);
      })
      .catch((error) => {
        console.log(error.response.data);

        setSeverity("error");
        setMessage(error.response.data.message);
        setOpenSnackbar(true);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <>
      <form>
        <Card sx={{ padding: "24px", borderRadius: "8px", boxShadow: 3 }}>
          <Box
            sx={{
              textAlign: "center",
              marginBottom: "40px",
              maxWidth: "800px",
            }}
          >
            <Typography
              variant="h5"
              sx={{
                fontWeight: "bold",
                color: "#333",
                marginBottom: "8px",
                textTransform: "uppercase",
                letterSpacing: "2px",
              }}
            >
              Enquiry Form
            </Typography>
          </Box>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                label="Type"
                variant="outlined"
                select
                value={isNeworExisting}
                onChange={(e) => setIsNewOrExisting(e.target.value)}
                fullWidth
                size="small"
              >
                <MenuItem value="New">New</MenuItem>
                <MenuItem value="Old">Existing</MenuItem>
              </TextField>
            </Grid>

            <Grid item xs={6}>
              <TextField
                label="Mobile Number"
                variant="outlined"
                value={mobileNumber}
                onChange={(e) => {
                  const value = e.target.value;
                  // Allow only numbers (digits) by checking with regex
                  if (/^[0-9]*$/.test(value)) {
                    setMobileNumber(value);
                    fetchDataByMobileNo(value);
                    setMobileNumberError(false); // Reset error state
                  }
                }}
                InputProps={{
                  inputProps: {
                    maxLength: 10, // Limit input length to 10 digits
                  },
                  endAdornment: mobileLoading && (
                    <InputAdornment position="end">
                      <CircularProgress size={20} />
                    </InputAdornment>
                  ),
                }}
                fullWidth
                size="small"
                required
                error={mobileNumberError}
                helperText={
                  mobileNumberError ? "Mobile Number is required" : ""
                }
              />
            </Grid>

            <Grid item xs={6}>
              <TextField
                label="Name"
                variant="outlined"
                value={farmer_name}
                onChange={(e) => {
                  const value = e.target.value;

                  // Allow only alphabets and spaces using regex
                  if (/^[a-zA-Z\s]*$/.test(value)) {
                    setFarmer_Name(value); // Update state if valid
                  }
                }}
                fullWidth
                size="small"
                InputProps={{
                  inputProps: {
                    maxLength: 150, // Limit input length to 10 digits
                  },
                }}
              />
            </Grid>

            <>
              <Grid item xs={12}>
                <TextField
                  label="Service Type"
                  variant="outlined"
                  select
                  value={buisnessType}
                  onChange={(e) => setBuisnessType(e.target.value)}
                  fullWidth
                  size="small"
                  required
                  error={buisnessTypeError}
                  helperText={
                    buisnessTypeError ? "Service Type is required" : ""
                  }
                >
                  <MenuItem value="Shrimp">Shrimp</MenuItem>
                  <MenuItem value="Fish">Fish</MenuItem>
                </TextField>
              </Grid>

              <Grid item xs={12}>
                <TextField
                  label="Farmer Category"
                  variant="outlined"
                  select
                  value={farmerCategory}
                  onChange={(e) => setFarmerCategory(e.target.value)}
                  fullWidth
                  size="small"
                >
                  <MenuItem value="Modern">Modern</MenuItem>
                  <MenuItem value="Traditional">Traditional</MenuItem>
                  <MenuItem value="Both">Both</MenuItem>
                </TextField>
              </Grid>

              <Grid item xs={6}>
                <TextField
                  label="Pond Location"
                  variant="outlined"
                  value={pondLocation}
                  onChange={(e) => setPondLocation(e.target.value)}
                  fullWidth
                  size="small"
                />
              </Grid>

              <Grid item xs={6}>
                <TextField
                  label="District"
                  variant="outlined"
                  value={district}
                  onChange={(e) => setDistrict(e.target.value)}
                  fullWidth
                  size="small"
                />
              </Grid>

              <Grid item xs={6}>
                <TextField
                  label="Postal Pincode"
                  variant="outlined"
                  value={pincode}
                  onChange={(e) => setPincode(e.target.value)}
                  fullWidth
                  size="small"
                />
              </Grid>

              <Grid item xs={6}>
                <TextField
                  label="State"
                  variant="outlined"
                  value={state}
                  onChange={(e) => setState(e.target.value)}
                  fullWidth
                  size="small"
                />
              </Grid>

              <Grid item xs={6}>
                <TextField
                  label="Fish Species"
                  variant="outlined"
                  value={fishSpecies}
                  onChange={(e) => setFishSpecies(e.target.value)}
                  fullWidth
                  size="small"
                />
              </Grid>

              <Grid item xs={6}>
                <TextField
                  label="No of Ponds"
                  variant="outlined"
                  value={noOfPonds}
                  onChange={(e) => setNoOfPonds(e.target.value)}
                  fullWidth
                  size="small"
                />
              </Grid>

              <Grid item xs={6}>
                <TextField
                  label="No of Tank/Bio Flock/RAS"
                  variant="outlined"
                  value={noOfTank}
                  onChange={(e) => setNoOfTank(e.target.value)}
                  fullWidth
                  size="small"
                />
              </Grid>

              <Grid item xs={6}>
                <TextField
                  label="Pond Area in Acres"
                  variant="outlined"
                  value={pondArea}
                  onChange={(e) => setPondArea(e.target.value)}
                  fullWidth
                  size="small"
                />
              </Grid>

              <Grid item xs={6}>
                <TextField
                  label="Current Feed Used"
                  variant="outlined"
                  value={currentfeed}
                  onChange={(e) =>{ 
                    setCurrentFeed(e.target.value);
                  setFeedUsedError(false);}}
                  fullWidth
                  size="small"
                  required
                  error={feedUsedError}
                  helperText={
                    feedUsedError ? "Current Feed Used is required" : ""
                  }
                >
                  
                </TextField>
              </Grid>

              <Grid item xs={6}>
                <TextField
                  label="Stocking"
                  variant="outlined"
                  value={stocking}
                  onChange={(e) =>{ setStocking(e.target.value);
                    setStockingError(false);
                  }}
                  fullWidth
                  select
                  size="small"
                  required
                  error={stockinError}
                  helperText={stockinError ? "Stocking is required" : ""}
                >
                  <MenuItem value="Yes">Yes</MenuItem>
                  <MenuItem value="No">No</MenuItem>
                </TextField>
              </Grid>

              {stocking === "yes" && (
                <Grid item xs={6}>
                  <TextField
                    label="Stocking Density"
                    variant="outlined"
                    value={stockingDensity}
                    onChange={(e) =>
                      setStockingDensity(
                        e.target.value === "" ? null : e.target.value
                      )
                    }
                    fullWidth
                    size="small"
                  />
                </Grid>
              )}

              {stocking === "yes" && (
                <Grid item xs={6}>
                  <TextField
                    label="Days of Culture"
                    variant="outlined"
                    value={daysOfCulture}
                    onChange={(e) => setDaysOfCulture(e.target.value)}
                    fullWidth
                    size="small"
                  />
                </Grid>
              )}

              {stocking === "yes" && (
                <Grid item xs={6}>
                  <TextField
                    label="Harvesting"
                    variant="outlined"
                    value={harvesting}
                    onChange={(e) => setHarvesting(e.target.value)}
                    fullWidth
                    size="small"
                    select
                  >
                    <MenuItem value="Yes">Yes</MenuItem>
                    <MenuItem value="No">No</MenuItem>
                  </TextField>
                </Grid>
              )}

              {harvesting === "yes" && (
                <Grid item xs={6}>
                  <TextField
                    label="Harvesting Quantity"
                    variant="outlined"
                    value={harvestingQuantity}
                    onChange={(e) => setHarvestingQuantity(e.target.value)}
                    fullWidth
                    size="small"
                  />
                </Grid>
              )}

              <Grid item xs={12}>
                <TextField
                  label="Potentiality in MT(Feed Consumption in Culture Period)"
                  variant="outlined"
                  value={potentiality}
                  onChange={(e) => setPotentiality(e.target.value)}
                  placeholder="0.0"
                  fullWidth
                  size="small"
                />
              </Grid>
            </>

            <>
              <Grid item xs={6}>
                <TextField
                  label="Purpose"
                  variant="outlined"
                  value={purpose}
                  onChange={(e) =>{ setPurpose(e.target.value);
                    setPurposeError(false);
                  }}
                  fullWidth
                  size="small"
                  select
                  required
                  error={purposeError}
                  helperText={purposeError ? "Purpose is required" : ""}
                >
                  <MenuItem value="Feed Requirement">Feed Requirement</MenuItem>
                  <MenuItem value="Technical Service">
                    Technical Service
                  </MenuItem>
                  <MenuItem value="Feed Issue">Feed Issue</MenuItem>
                  <MenuItem value="Service Issue">Service Issue</MenuItem>
                  <MenuItem value="Dealership Enquiry">
                    Dealership Enquiry
                  </MenuItem>
                </TextField>
              </Grid>
            </>

            <Grid item xs={6}>
              <TextField
                label="Status"
                variant="outlined"
                value={status}
                onChange={(e) => {setStatus(e.target.value);
                  setStatusError(false);
                }}
                fullWidth
                size="small"
                select
                required
                error={statusError}
                helperText={statusError ? "Status is required" : ""}
              >
                <MenuItem value="Open">Open</MenuItem>
                <MenuItem value="Close">Closed</MenuItem>
                <MenuItem value="In Process">In-Process</MenuItem>
              </TextField>
            </Grid>

            {status != "Close" && (
              <Grid item xs={6}>
                <TextField
                  label="Follow-up Date"
                  type="date"
                  fullWidth
                  size="small"
                  InputLabelProps={{ shrink: true }}
                  value={
                    followUpDate ? dayjs(followUpDate).format("YYYY-MM-DD") : ""
                  }
                  onChange={(e) => {
                    const selectedDate = e.target.value; // Get the value from the event
                    setFollowUpDate(selectedDate); // Set the formatted date directly
                    setFollowUpDateError(false); // Reset error state
                  }}
                  inputProps={{
                    min: dayjs().add(1, "day").format("YYYY-MM-DD"), // Disable today and past dates
                  }}
                  required
                  error={followUpDateError}
                  helperText={
                    followUpDateError ? "Follow-up Date is required" : ""
                  }
                />
              </Grid>
            )}

            <Grid item xs={12}>
              <TextField
                label="Remarks"
                id="outlined-size-small"
                name="remarks"
                multiline
                rows={4}
                value={remarks}
                inputProps={{
                  maxLength: 1000,
                }}
                onChange={(e) => {
                  const newRemark = e.target.value.slice(0, 1000); // Trim to 250 characters
                  setRemarks(newRemark);
                }}
                size="small"
                fullWidth
              />
              <Typography
                variant="body2"
                color={remarks?.length > 1000 ? "error" : "text.secondary"}
                sx={{ marginLeft: "7px" }}
              >
                {remarks?.length}/1000
              </Typography>
            </Grid>

            <Grid container justifyContent="flex-end" sx={{ marginTop: 2 }}>
              <Button
                variant="contained"
                color="primary"
                size="large"
                onClick={handleSubmit}
                disabled={loading}
              >
                {loading ? "Submitting..." : "Submit"}
              </Button>
            </Grid>
          </Grid>
        </Card>
      </form>
    </>
  );
};

export default FormComponent;
